// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"a4277efd","942":"a4277efd"}[chunkId] + ".chunk.css";
};